import { render, staticRenderFns } from "./bookDetail.vue?vue&type=template&id=7b827b95&"
import script from "./bookDetail.vue?vue&type=script&lang=js&"
export * from "./bookDetail.vue?vue&type=script&lang=js&"
import style0 from "./bookDetail.vue?vue&type=style&index=0&id=7b827b95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports